/**
 * Правила сравнения чисел, которые ПОКАЗЫВАЮТСЯ человеку.
 *
 * Отдельный модуль, потому что правило одно, а мест применения уже два —
 * дерево выбора («13 958 га пашни · 15 429 всего») и карточка площади на
 * экране полей. Одинаковое правило, живущее в двух файлах, — это тот самый
 * случай, когда через месяц оно разъезжается на единицу и никто не может
 * объяснить, почему на одном экране вторая цифра есть, а на соседнем нет.
 */

/**
 * Различаются ли числа ПОСЛЕ округления до целого — то есть увидит ли
 * человек два разных числа.
 *
 * Сравнивать сырые значения нельзя: площади приходят из `numeric`, и на
 * хозяйстве без пастбищ разница в сотые доли гектара давала подпись
 * «13 958 га пашни · 13 958 всего» — два одинаковых числа, притворяющихся
 * разными. `null`/`undefined` = «нечего сравнивать», не «различаются».
 */
export function differsAfterRounding(
  a: number | null | undefined,
  b: number | null | undefined,
): boolean {
  if (a == null || b == null) return false;
  return Math.round(a) !== Math.round(b);
}
